<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/typography";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .notification-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    pointer-events: none;
  }

  .notification {
    background: colors.get(systemPositive_10);
    border-radius: 0 0 4px 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    position: relative;
    padding: 12px 10px;
    gap: 8px;
    width: 100%;

    .text {
      @include mixins.body4();
      color: colors.get(systemPositive_100);
      text-align: left;
      width: 100%;
    }
  }
</style>

<script>
  import { slide } from "svelte/transition";
  import { diallerState } from "../diallerState.svelte";
  import Icon from "../../../../../../svelte-design-system/components/atoms/Icon.svelte";
  import IconButton from "../../../../../../svelte-design-system/components/atoms/IconButton.svelte";

  const handleClose = () => {
    diallerState.showSaveNotification = false;
  };
</script>

{#if diallerState.showSaveNotification}
  <div class="notification-container">
    <div
      class="notification"
      in:slide={{ duration: 400, axis: "y" }}
      out:slide={{ duration: 300, axis: "y" }}
    >
      <Icon class="fa-solid fa-circle-check color-systemPositive_100" />
      <div class="text">
        Success! Contact details may take a few seconds to appear
      </div>

      <IconButton
        icon="fa-solid fa-xmark"
        onclick={handleClose}
        aria-label="Close notification"
        size="small"
        color="primary_80"
        mouseEnterColor="primary_60"
        focusColor="primary_40"
      />
    </div>
  </div>
{/if}
